import {Pagination, Segmented, Select} from 'antd';
import {Section} from 'pages/home/shared/DashboardUI';
import {TicketList} from './TicketList';
import {
  DETAIL_DEFAULT_TAB,
  DETAIL_PAGE_SIZE,
  TICKET_SORTS,
  TICKET_TABS,
} from './performanceUtils';
import styles from './performance.module.scss';

const DESCRIPTIONS = {
  ALL: 'Opened, resolved or abandoned in the period, plus everything pending now — so the total is not the resolved count.',
  RESOLVED: 'Tickets resolved in the period.',
  PENDING: 'Live: tickets still open right now, whatever the dates.',
};

const EMPTY = {
  ALL: 'No tickets for these filters',
  RESOLVED: 'Nothing resolved in this period',
  PENDING: 'Nothing pending right now',
};

/**
 * One ticket list with its All / Closed / Pending tabs, order and pages, all
 * kept in the URL. A pending list shows the oldest first unless the viewer
 * picks another order.
 */
export const TicketsSection = ({
  title = 'Tickets',
  filters,
  update,
  tickets,
  pagination,
  loading,
  actions,
  defaultTab = DETAIL_DEFAULT_TAB,
}) => {
  const tab = filters.tickets || defaultTab;
  const sort =
    filters.sort || (tab === 'PENDING' ? 'OLDEST_OPENED' : 'RECENTLY_RESOLVED');
  return (
    <Section
      title={title}
      description={DESCRIPTIONS[tab]}
      actions={
        <div className={styles.headActions}>
          <Segmented
            size="small"
            value={tab}
            onChange={value => update({tickets: value, sort: null})}
            options={TICKET_TABS}
          />
          <Select
            size="small"
            className={styles.sortSelect}
            value={sort}
            onChange={value => update({sort: value})}
            options={TICKET_SORTS}
            aria-label="Order tickets by"
          />
          {actions}
        </div>
      }>
      <TicketList tickets={tickets} loading={loading} emptyText={EMPTY[tab]} />
      {pagination?.total > 0 && (
        <Pagination
          className={styles.pager}
          current={filters.page}
          pageSize={DETAIL_PAGE_SIZE}
          total={pagination.total}
          showSizeChanger={false}
          onChange={page => update({page})}
          showTotal={total => `${total} tickets`}
        />
      )}
    </Section>
  );
};
